import { render, staticRenderFns } from "./TerminalRequestTelesalesView.vue?vue&type=template&id=bcd2d87c&scoped=true&"
import script from "./TerminalRequestTelesalesView.vue?vue&type=script&lang=js&"
export * from "./TerminalRequestTelesalesView.vue?vue&type=script&lang=js&"
import style0 from "./TerminalRequestTelesalesView.vue?vue&type=style&index=0&id=bcd2d87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd2d87c",
  null
  
)

export default component.exports